import React, { useRef, useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";
import {Link, useNavigate} from 'react-router-dom';


const missions = [
    {
        date: "Mercredi 14",
        month: "Mars 2025",
        role: "Réceptionniste",
        salary: "Salaire",
        address: "Adresse",
        duration: "2 jours",
        deadline: "Jusqu'au vendredi 16 janvier",
        accepted: false
    },
    {
        date: "Mercredi 15",
        month: "Mars 2025",
        role: "Réceptionniste",
        salary: "Salaire",
        address: "Adresse",
        duration: "2 jours",
        deadline: "Jusqu'au vendredi 16 janvier",
        accepted: false
    },{
        date: "Mercredi 16",
        month: "Mars 2025",
        role: "Réceptionniste",
        salary: "Salaire",
        address: "Adresse",
        duration: "2 jours",
        deadline: "Jusqu'au vendredi 16 janvier",
        accepted: false
    },
    // Ajoute autant de missions que tu veux ici
];

export default function MissionSuggestions() {
    const [missionsList, setMissionsList] = useState(missions);

    const [transitioning, setTransitioning] = useState(false);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/mission-detail');
    };

    const handleAccept = (index) => {
        const updated = missionsList.map((m, i) =>
            i === index ? { ...m, accepted: true } : m
        );
        setMissionsList(updated);
    };

    const handleNext = () => {
        setTransitioning(true);
        setTimeout(() => {
            const next = missionsList.slice(1);




            setMissionsList(next);
            setTransitioning(false);
        }, 600); // correspond à la durée de l’animation CSS
    };

    const handleRefuse = () => {
        handleNext();
    };

    return (
        <div className="missions-suggestions-widget ">
            <div>
                <h3>Propositions de missions</h3>
                <span className={"dot"}> {missionsList.length} </span>
            </div>
            <Link to={"/job-offer"}>Voir toutes les missions</Link>
            <div className={`card-container ${transitioning ? "fade-out" : ""}`}>
                {missionsList.map((mission, index) => (
                    <article key={index} className={mission.accepted ? "accepted" : ""}>
                        {!mission.accepted ? (
                            <>
                        <div>
                            <p>{mission.date}</p>
                            <p>{mission.month}</p>
                            <p>{mission.role}</p>
                            <p>{mission.salary}</p>
                            <p>{mission.address}</p>
                        </div>
                        <span className={"arrow"} />
                        <div>
                            <p>{mission.duration}</p>
                            <p>{mission.deadline}</p>
                            <Link to={"/mission-detail"}>Voir les détails</Link>
                            <div className={"buttons"}>
                                <button className={"btn fill green"} onClick={() => handleAccept(index)}>Accepter</button>
                                <button className={"btn empty red"} onClick={handleRefuse}>Refuser</button>
                            </div>
                        </div>
                            </>
                        ) : (
                            <>
                                <div className="confirmation">
                                    <CheckCircle size={48} color="white" />
                                    <p className="message">Mission acceptée !</p>
                                    <button className="btn white" onClick={handleClick}>Voir plus de détails</button>
                                    <button className="btn empty white" onClick={handleNext}>
                                        Voir la mission suivante
                                    </button>
                                </div>
                            </>
                        )}
                    </article>
                ))}
                {Array.from({ length: 3 - missionsList.length })
                    .fill(null)
                    .map((_, index) => (
                        <article className="Empty-mission"
                            key={`empty-${index}`}
                        >
                            <p>
                                Il n'y a pas de mission à afficher pour le moment.
                            </p>
                        </article>
                    ))}
            </div>
        </div>

    );
}